
define('app/board/models/draftOptionsModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var DraftOptionsModel = Backbone.Model.extend({	
		defaults: {
			id: null, //Just the lgInstId
			pickWidth: 50,
			fontSize: 12,
			fontHeight: 17,
			teamFontSize: 12,
			playerSmallFontSize: 16,
			playerSmallFontHeight: 18,
			playerLargeFontSize: 24,
			playerLargFontHeight: 36,
			hideActivityIcon: true,
			hideFName: false,
			hidePlayerInfo: false,
			hideRoundPosInfo: true
	    },

	    initialize: function(models, options) {
	    	var numTeams = options.numTeams;
	    	this.lgInst = options.lgInst;
	    	
	    	if(typeof localStorage !== 'undefined' && localStorage.getItem(this.lgInst.get('id') + ":pickSizingOptions")){
	    		var savedOptions = JSON.parse(localStorage.getItem(this.lgInst.get('id') + ":pickSizingOptions"));
	    		
	    		/*this.set({
	    			pickWidth: savedOptions.pickWidth ? savedOptions.pickWidth : this.defaults.pickWidth,
		    		fontSize: savedOptions.fontSize ? savedOptions.fontSize : this.defaults.fontSize,
		    		fontHeight: savedOptions.fontHeight ? savedOptions.fontHeight : this.defaults.fontHeight,
		    		playerSmallFontSize: savedOptions.playerSmallFontSize ? savedOptions.playerSmallFontSize : this.defaults.playerSmallFontSize,
		    		playerSmallFontHeight: savedOptions.playerSmallFontHeight ? savedOptions.playerSmallFontHeight : this.defaults.playerSmallFontHeight,
		    		playerLargeFontSize: savedOptions.playerLargeFontSize ? savedOptions.playerLargeFontSize : this.defaults.playerLargeFontSize,
		    		playerLargFontHeight: savedOptions.playerLargFontHeight ? savedOptions.playerLargFontHeight : this.defaults.playerLargFontHeight,
		    	});*/
	    		
	    		this.set(savedOptions);
	    	} else {
	    		this.initializeWidth(numTeams);
	    	}
	    },
	    
	    initializeWidth: function(numTeams) {
	    	var boardWidth = $(document).width() - 53 - (numTeams * 10); //subtract round column and space for padding
	    	var pickWidth = Math.floor(boardWidth/numTeams);
	    	var minWidth = 75;
	    	
	    	if(this.lgInst.get('draftType') == 'AUCTION'){
	    		minWidth = 90;
	    	}
	    	
	    	if(pickWidth < minWidth){
	    		pickWidth = minWidth;
	    		this.configText(this.get('playerLargeFontSize') - 9);
	    	} else if(pickWidth < 100){
	    		this.configText(this.get('playerLargeFontSize') - 6);
	    	}

			this.set('pickWidth', pickWidth);
	    },
	    
	    increaseText: function() {
	    	this.configText(this.get('playerLargeFontSize') + 3);
			this.saveToLocalStorage();
	    },
	    
	    reduceText: function() {
	    	this.configText(this.get('playerLargeFontSize') - 3);
			this.saveToLocalStorage();
	    },
	    
	    increasePickWidth: function() {
	    	this.set('pickWidth', this.get('pickWidth') + 5);
	    	this.saveToLocalStorage();
	    },
	    
	    reducePickWidth: function() {
	    	this.set('pickWidth', this.get('pickWidth') - 5);
	    	this.saveToLocalStorage();
	    },
	    
	    increaseTeamText: function() {
	    	this.set('teamFontSize', this.get('teamFontSize') + 2);
			this.saveToLocalStorage();
	    },
	    
	    reduceTeamText: function() {
	    	this.set('teamFontSize', this.get('teamFontSize') - 2);
			this.saveToLocalStorage();
	    },

		hideActivity: function(hidden) {
	    	this.set('hideActivityIcon', hidden);
	    	this.saveToLocalStorage();
	    },
	    
	    hidePlayerFirstName: function(hidden) {
	    	this.set('hideFName', hidden);
	    	this.saveToLocalStorage();
	    },
	    
	    hidePlayerInfo: function(hidden) {
	    	this.set('hidePlayerInfo', hidden);
	    	this.saveToLocalStorage();
	    },
	    
	    hideRoundPosInfo: function(hidden) {
	    	this.set('hideRoundPosInfo', hidden);
	    	this.saveToLocalStorage();
	    },
	    
	    configText: function(baseTextHeight) {
	    	this.set({
	    		fontSize: Math.floor(baseTextHeight/2),
	    		fontHeight: Math.floor(baseTextHeight/2)+Math.floor(baseTextHeight/6),
	    		playerSmallFontSize: Math.floor(baseTextHeight*(2/3)),
	    		playerSmallFontHeight: Math.floor(baseTextHeight*(2/3))+Math.floor(baseTextHeight/12),
	    		playerLargeFontSize: baseTextHeight,
	    		playerLargFontHeight: baseTextHeight+Math.floor(baseTextHeight/2)
	    	});
	    },
	    
	    saveToLocalStorage: function() {
	    	if(typeof localStorage !== 'undefined' && $.isLocalStorageSaveSupported()){
	    		var savedOptions = this.toJSON();
	    		
	    		localStorage.setItem(this.lgInst.get('id') + ":pickSizingOptions", JSON.stringify(savedOptions));
	    	}
	    }
	});
	
	
	
	return DraftOptionsModel;  
});